import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=24d7816e&"
import script from "./FormTextarea.vue?vue&type=script&lang=js&"
export * from "./FormTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d7816e')) {
      api.createRecord('24d7816e', component.options)
    } else {
      api.reload('24d7816e', component.options)
    }
    module.hot.accept("./FormTextarea.vue?vue&type=template&id=24d7816e&", function () {
      api.rerender('24d7816e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormTextarea.vue"
export default component.exports